import { selectMultiplePromosModelResponseSchema, selectPromoModelResponseSchema } from './promozavr-schema';
import type { SelectMultiplePromosModelResponse, SelectPromoModelResponse } from './types/promozavr';

export function isSelectPromoModelResponse(value: unknown): value is SelectPromoModelResponse {
    return selectPromoModelResponseSchema.safeParse(value).success;
}

export function isSelectMultiplePromosModelResponse(value: unknown): value is SelectMultiplePromosModelResponse {
    return selectMultiplePromosModelResponseSchema.safeParse(value).success;
}
